import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';

// Nav tab icons from figma/icons/*.svg, used verbatim.
// Colour is tintable so active/inactive states can differ.

export function ExploreIcon({ size = 22, color }: { size?: number; color: string }) {
  // figma/icons/Explore.svg (17x16) — folded map
  return (
    <Svg width={size} height={(size * 16) / 17} viewBox="0 0 17 16">
      <Path
        d="M0.899902 3.26517V14.8359L4.95879 12.7313L11.1833 14.8359L15.6134 12.3739V0.835938L11.0471 3.26517L4.95879 0.835938L0.899902 3.26517Z"
        stroke={color}
        strokeWidth={1.8}
        strokeLinejoin="bevel"
      />
      <Path d="M4.96045 12.7299V1.15918" stroke={color} strokeWidth={1.8} strokeLinejoin="bevel" />
      <Path d="M11.0491 14.3071V2.73633" stroke={color} strokeWidth={1.8} strokeLinejoin="bevel" />
    </Svg>
  );
}

export function GroupsIcon({ size = 22, color }: { size?: number; color: string }) {
  // figma/icons/Groups.svg (18x14) — two people
  return (
    <Svg width={size} height={(size * 14) / 18} viewBox="0 0 18 14">
      <Path
        d="M11.9254 7.875C14.8249 7.875 17.1754 10.2255 17.1754 13.125V14H15.4254V13.125C15.4254 11.228 13.9163 9.68448 12.0331 9.62756C11.4443 8.87398 10.6713 8.27147 9.77979 7.89124C9.91043 7.8815 10.0423 7.875 10.1754 7.875H11.9254Z"
        fill={color}
      />
      <Path
        d="M10.738 0C12.671 0 14.238 1.567 14.238 3.5C14.238 5.433 12.671 7 10.738 7C10.2396 7 9.76588 6.89473 9.33667 6.70691C9.78447 6.29149 10.1454 5.78429 10.3885 5.21411C10.5015 5.23702 10.6183 5.25 10.738 5.25C11.7045 5.25 12.488 4.4665 12.488 3.5C12.488 2.5335 11.7045 1.75 10.738 1.75C10.6183 1.75 10.5015 1.76214 10.3885 1.78503C10.1454 1.21496 9.78448 0.707556 9.33667 0.292236C9.76579 0.104501 10.2397 0 10.738 0Z"
        fill={color}
      />
      <Path
        d="M0.899902 14V13.75C0.899902 10.9886 3.13848 8.75 5.8999 8.75H6.3999C9.16133 8.75 11.3999 10.9886 11.3999 13.75V14"
        stroke={color}
        strokeWidth={1.8}
        strokeLinejoin="bevel"
      />
      <Rect x={3.5499} y={0.9} width={5.2} height={5.2} rx={2.6} stroke={color} strokeWidth={1.8} />
    </Svg>
  );
}

export function ProfileIcon({ size = 22, color }: { size?: number; color: string }) {
  // figma/icons/Profile.svg (13x14) — person
  return (
    <Svg width={size} height={(size * 14) / 13} viewBox="0 0 13 14">
      <Path
        d="M0.899902 14V13.75C0.899902 10.9886 3.13848 8.75 5.8999 8.75H6.3999C9.16133 8.75 11.3999 10.9886 11.3999 13.75V14"
        stroke={color}
        strokeWidth={1.8}
        strokeLinejoin="bevel"
      />
      <Rect x={3.5499} y={0.9} width={5.2} height={5.2} rx={2.6} stroke={color} strokeWidth={1.8} />
    </Svg>
  );
}

export function BellIcon({ size = 22, color }: { size?: number; color: string }) {
  // figma/icons/bell.svg (14x15)
  return (
    <Svg width={size} height={(size * 15) / 14} viewBox="0 0 14 15">
      <Path
        d="M0.666016 11.5029L0.650391 11.4482C0.618322 11.3761 0.545043 11.2403 0.460938 11.084C0.53215 11.0641 0.600565 11.0408 0.666016 11.0127V11.5029ZM12.5674 11.0137C12.6326 11.0415 12.7006 11.0652 12.7715 11.085C12.6884 11.2404 12.6174 11.3763 12.585 11.4482L12.5674 11.5029V11.0137ZM7.93555 0.900391C8.28544 1.24605 8.62326 1.53861 8.92188 1.79688C9.31061 2.13308 9.61422 2.39862 9.86719 2.68652C10.3157 3.19709 10.6416 3.81701 10.6416 5.08203H11.542L10.6416 5.08301V5.10156C10.6417 5.11296 10.6423 5.12973 10.6426 5.15039C10.6431 5.19166 10.6437 5.25078 10.6455 5.3252C10.6491 5.47428 10.656 5.68567 10.6699 5.93848C10.6975 6.44118 10.7525 7.12189 10.8652 7.81055C10.9755 8.48435 11.1517 9.23361 11.4473 9.83691C11.5676 10.0825 11.7391 10.3638 11.9746 10.6025H1.25684C1.49243 10.364 1.6645 10.0828 1.78516 9.83691C2.08133 9.23328 2.25695 8.48351 2.36719 7.80957C2.47977 7.12112 2.53509 6.44107 2.5625 5.93848C2.57627 5.68584 2.58245 5.47428 2.58594 5.3252C2.58768 5.25058 2.58939 5.19073 2.58984 5.14941V5.08203L2.59375 4.85156C2.63118 3.73879 2.94334 3.16467 3.36328 2.68652C3.61604 2.39874 3.91973 2.13389 4.30859 1.79785C4.6075 1.53955 4.9453 1.24625 5.2959 0.900391H7.93555Z"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
      <Path
        d="M8.31279 13.2783C7.85034 13.7407 7.22312 14.0005 6.56912 14.0005C5.91511 14.0005 5.28789 13.7407 4.82544 13.2783"
        stroke={color}
        strokeWidth={1.4}
        strokeLinecap="square"
        strokeLinejoin="bevel"
      />
    </Svg>
  );
}

export function HamburgerIcon({ size = 22, color }: { size?: number; color: string }) {
  // figma/icons/hamburger.svg (14x14)
  return (
    <Svg width={size} height={size} viewBox="0 0 14 14">
      <Path d="M0 12.9004H14" stroke={color} strokeWidth={1.8} strokeLinejoin="bevel" />
      <Path d="M0 6.90039H14" stroke={color} strokeWidth={1.8} strokeLinejoin="bevel" />
      <Path d="M0 0.900391H14" stroke={color} strokeWidth={1.8} strokeLinejoin="bevel" />
    </Svg>
  );
}

export function RecordIcon({ size = 22, color }: { size?: number; color: string }) {
  // figma/icons/Record.svg (16x16) — navigation arrow
  return (
    <Svg width={size} height={size} viewBox="0 0 16 16">
      <Path
        d="M5.68412 9.49273C5.95623 10.4517 7.68188 14.8135 7.68188 14.8135L14.385 0.813477L0.38501 7.43806C0.38501 7.43806 4.74549 9.22204 5.68412 9.49273Z"
        stroke={color}
        strokeWidth={1.8}
        strokeLinejoin="bevel"
      />
    </Svg>
  );
}